"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapAccounts = exports.enableWeb3Extension = exports.getWindowExtension = exports.getExtensions = exports.changeAddressFormat = void 0;
const tslib_1 = require("tslib");
const util_1 = require("@polkadot/extension-dapp/util");
const util_2 = require("@polkadot/util");
const util_crypto_1 = require("@polkadot/util-crypto");
function changeAddressFormat(address, ss58Format) {
    return (0, util_crypto_1.encodeAddress)((0, util_crypto_1.decodeAddress)(address), ss58Format);
}
exports.changeAddressFormat = changeAddressFormat;
function getExtensions() {
    const win = window;
    return win.injectedWeb3 || {};
}
exports.getExtensions = getExtensions;
/**
 * Retrieves a given extension if available on the window
 * @throws if no extensionName is provided
 */
function getWindowExtension(originName, extensionName) {
    return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
        const win = window;
        const extension = win.injectedWeb3[extensionName];
        if (!extension) {
            throw new Error(`Extension '${extensionName}' not found`);
        }
        const { connect, enable, version } = extension;
        if (connect) {
            // new style, returning all info
            return connect(originName);
        }
        if (enable) {
            // previous interface, leakages on name/version
            return enable(originName)
                .then(e => (0, util_2.objectSpread)({ name: extensionName, version: version || 'unknown' }, e))
                .catch((error) => {
                console.error(`Error initializing '${extensionName}': ${error.message}`);
                throw error;
            });
        }
        throw new Error(`Extension '${extensionName}' does not provide 'connect' or 'enable' hooks`);
    });
}
exports.getWindowExtension = getWindowExtension;
/**
 * Enables a given providers found on the injected window interface
 */
function enableWeb3Extension(originName, extensionName = 'polywallet') {
    return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
        if (!originName.trim().length) {
            throw new Error('You must pass a name for your app to enable the given extension');
        }
        if (!extensionName.trim().length) {
            throw new Error('extensionName cannot be empty');
        }
        return (0, util_1.documentReadyPromise)(() => getWindowExtension(originName, extensionName).then(extension => {
            const { name, version, accounts } = extension;
            // if we don't have an accounts subscriber, add a single-shot version
            if (!accounts.subscribe) {
                accounts.subscribe = (cb) => {
                    accounts.get().then(cb).catch(console.error);
                    return () => {
                        // no unsubscribe needed, this is a single-shot
                    };
                };
            }
            console.log(`enableWeb3Extension: Enabled '${name}/${version}' extension`);
            return extension;
        }));
    });
}
exports.enableWeb3Extension = enableWeb3Extension;
/**
 * Maps Array<InjectedAccount> -> Array<InjectedAccountWithMeta>
 */
function mapAccounts(source, list, ss58Format) {
    return list.map(({ address, genesisHash, name, type }) => ({
        address: changeAddressFormat(address, ss58Format),
        meta: { genesisHash, name, source },
        type,
    }));
}
exports.mapAccounts = mapAccounts;
//# sourceMappingURL=index.js.map